import { z } from 'zod';

export const chartAnswerSchema = z
  .object({
    text: z.string(),
    context: z.object({
      documents: z.array(z.string()).default([]),
      folders: z.array(z.string()).default([]),
    }),
    llm_model: z.string(),
    id: z.uuid(),
    role: z.literal(['USER', 'ASSISTANT']),
    session_id: z.uuid(),
    author_id: z.string().nullable(),
    organization_id: z.number().int(),
    rating: z.number().int().nullable(),
    created_at: z.iso.datetime({ offset: true }),
    updated_at: z.iso.datetime({ offset: true }),
  })
  .transform((raw) => ({
    id: raw.id,
    text: raw.text,
    context: {
      documents: raw.context?.documents ?? [],
      folders: raw.context?.folders ?? [],
    },
    llmModel: raw.llm_model,
    role: raw.role,
    sessionId: raw.session_id,
    authorId: raw.author_id,
    organizationId: raw.organization_id,
    rating: raw.rating,
    createdAt: raw.created_at,
    updatedAt: raw.updated_at,
  }));

export type ChartAnswerApi = z.input<typeof chartAnswerSchema>;
export type ChartAnswer = z.infer<typeof chartAnswerSchema>;
